import { defineNuxtPlugin } from '#app';

export default defineNuxtPlugin(() => {
  const { public: { feedbucket } } = useRuntimeConfig();

  if (feedbucket.active && feedbucket.projectId) {
    useHead({
      script: [
        {
          id: 'FeedBucket',
          src: 'https://cdn.feedbucket.app/assets/feedbucket.js',
          crossorigin: 'anonymous',
          defer: true,
          // @ts-expect-error
          module: true,
          'data-feedbucket': feedbucket.projectId,
        },
      ],
    });
  }
});
